import React from 'react';
import {WeaSearchGroup, WeaFormItem, WeaCheckbox} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EType from './base/EType';
import ETitle from './base/ETitle';
import EShowNum from './base/EShowNum';
import ELinkMode from './base/ELinkMode';
import EScrollDirection from './base/EScrollDirection';
// 建模查询中心
export default class Content_FormModeCustomSearch extends React.Component {
    state = {
        eIsShowTitle: this.props.eIsShowTitle,
        weaCubeLoaded: false,
        cubeQueryCenterStore:undefined,
    };

    componentWillMount() {
        // 异步加载表单建模模块静态资源
        eventRegister.loadModule('b_cube', () => {
            setTimeout(() => {const cubeQueryCenterStore=new window.weaCubeEngine.com.CubeQueryCenterStore();this.setState({weaCubeLoaded: true,cubeQueryCenterStore:cubeQueryCenterStore})}, 100);
        }, () => {
        });
    }

    render() {
        const {eIsShowTitle, weaCubeLoaded,cubeQueryCenterStore} = this.state;
        return (
            <div>
                <WeaSearchGroup title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>
                    <EType ref="eType" value={this.props.eBaseName}/>
                    {this.props.eShareLevel == '2' ? <ETitle ref="eTitle" eid={this.props.eid} value={this.props.eTitle}/> : ''}
                    {this.props.eShareLevel == '2' ? <EShowNum ref="eShowNum" value={this.props.eShowNum}/> : ''}
                    {this.props.eShareLevel == '2' ? <ELinkMode ref="eLinkMode" options={this.props.eLinkMode.options} value={(this.props.eLinkMode.selected == '-1' ? '2' : this.props.eLinkMode.selected) || '2'}/> : ''}
                    {
                        this.props.eShareLevel == '2' ? (
                                <WeaFormItem label={getLabel(127782, '是否显示标题')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                                    <div className="portal-FormModeCustomSearch-perpage">
                                        <WeaCheckbox value={eIsShowTitle} onChange={(value) => this.setState({eIsShowTitle: value == '1'})}/>
                                    </div>
                                </WeaFormItem>
                            ) : ''
                    }
                    {this.props.eShareLevel == '2' ? <EScrollDirection ref="eScrollDirection" options={this.props.eScrollDirection.options} value={this.props.eScrollDirection.selected}/> : ''}
                    {
                        this.props.eShareLevel == '2' ? (
                                <WeaFormItem  wrapperCol={{span: 22}}>
                                    {weaCubeLoaded && window.weaCubeEngine && window.weaCubeEngine.com ? <window.weaCubeEngine.com.CubeQueryCenterSet 
                                    CubeQueryCenterStore={cubeQueryCenterStore} 
                                    isCustom={true} eid={this.props.eid} hpid={this.props.hpid}
                                    /> 
                                    : <div></div>}
                                </WeaFormItem>
                            ) : ''
                    }
                </WeaSearchGroup>
            </div>
        );
    }

    getSaveValues() {
        return {
            eContentTitle: this.refs['eTitle'] ? this.refs['eTitle'].getSaveValues() : this.props.eTitle,
            eContentShowNum: this.refs['eShowNum'].getSaveValues(),
            eContentLinkMode: this.refs['eLinkMode'].getSaveValues(),
            eContentIsShowTitle: this.state.eIsShowTitle,
            eContentTabWidth: {tabwidth: this.props.etabwidth, methodvalue: this.props.methodvalue},
            eContentScrollDirection: this.refs['eScrollDirection'] ? this.refs['eScrollDirection'].getSaveValues() : this.props.eScrollDirection.selected,
        };
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_FormModeCustomSearch.js